import { LOGIN_KIND, type User } from '../types/userType';

export const ENTRA_ID_IDENTITY_STORAGE_KEY = 'entra_id_identity';

const isEntraIdentity = (value: Partial<User> | null): value is User => {
  if (!value || value.loginKind !== LOGIN_KIND.ENTRA_ID) {
    return false;
  }
  return true;
};

export const persistEntraIdIdentity = (user: User): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(
    ENTRA_ID_IDENTITY_STORAGE_KEY,
    JSON.stringify({
      loginKind: LOGIN_KIND.ENTRA_ID,
      chaveM: user.chaveM,
      email: user.email,
    }),
  );
};

export const readEntraIdIdentity = (): User | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const raw = window.localStorage.getItem(ENTRA_ID_IDENTITY_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<User>;
    return isEntraIdentity(parsed)
      ? {
          loginKind: LOGIN_KIND.ENTRA_ID,
          chaveM: parsed.chaveM?.trim() || undefined,
          email: parsed.email?.trim() || undefined,
        }
      : null;
  } catch {
    return null;
  }
};

export const clearEntraIdIdentity = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(ENTRA_ID_IDENTITY_STORAGE_KEY);
};
